import { BestPracticeCheck } from '@cast/types';

import { CheckResourceState } from 'features/security-insights';

import { useStandardCriteria } from '../../_hooks/useStandardCriteria';

import {
  makeSearchBoxCriterion,
  SearchBoxCriterion,
} from '@cast/shared-search-ui';

const baseCriteria: SearchBoxCriterion<BestPracticeCheck>[] = [
  makeSearchBoxCriterion<BestPracticeCheck>({
    key: 'Check:',
    prop: 'name',
  }),
  {
    key: 'severity',
  },
  {
    key: 'type',
    getValue: (o) => (o.manual ? 'manual' : 'automatic'),
    matcher: 'exact',
  },
  { key: 'clusterIds' },
  { key: 'namespaces' },
  { key: 'labels' },
  {
    key: 'resource',
    getValue: (o) => {
      return o.failed
        ? CheckResourceState.AFFECTED
        : CheckResourceState.UNAFFECTED;
    },
    initialValue: CheckResourceState.AFFECTED,
    matcher: 'exact',
  },
];

type UseComplianceCheckCriteriaProps = {
  clusterIds?: string[];
};

export const useComplianceCheckCriteria = ({
  clusterIds,
}: UseComplianceCheckCriteriaProps = {}):
  | SearchBoxCriterion<BestPracticeCheck>[]
  | undefined => {
  const standardCriteria = useStandardCriteria({ clusterIds });
  return [...baseCriteria, standardCriteria];
};
